import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IMainReducerState,
  ReducersEnum,
} from "../../tsmodels/ReduxModel";

const initialState: IMainReducerState = {
  data: null
};

const mainSlice = createSlice({
  name: ReducersEnum.MAIN,
  initialState,
  reducers: {
    updateData: (
      state,
      action: PayloadAction<any>
    ) => ({
      ...state,
      data: action.payload,
    }),


  },

  // extraReducers: (builder) => {
  //   builder
  //     .addCase(getFilteredData.pending, (state, action) => {
  //       console.log("getDataSets loading");
  //     })
  //     .addCase(getFilteredData.fulfilled, (state, action) => ({
  //       ...state,
  //       filteredData: action.payload.data,
  //     }))
  // },
});

export const {
  updateData
} = mainSlice.actions;

export default mainSlice.reducer;
